export const sliderClasses = `
  @font-face {
     font-family: swiper-icons;
     src: url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');
     font-weight: 400;
     font-style: normal
 }

 .swiper-container {
     margin-left: auto;
     margin-right: auto;
     //position: relative;
     overflow: hidden;
     list-style: none;
     padding: 0;
     z-index: 1
 }

 .swiper-container-vertical>.swiper-wrapper {
     flex-direction: column
 }

 .swiper-wrapper {
     position: relative;
     width: 100%;
     height: 100% !important;
     z-index: 1;
     display: flex;
     transition-property: transform;
     box-sizing: content-box
 }
 .swiper {
    overflow: hidden;
 }
 .swiper-container-android .swiper-slide,
 .swiper-wrapper {
     transform: translate3d(0px, 0, 0)
 }

 .swiper-container-multirow>.swiper-wrapper {
     flex-wrap: wrap
 }

 .swiper-container-multirow-column>.swiper-wrapper {
     flex-wrap: wrap;
     flex-direction: column
 }

 .swiper-container-free-mode>.swiper-wrapper {
     transition-timing-function: ease-out;
     margin: 0 auto
 }

 .swiper-container-pointer-events {
     touch-action: pan-y
 }

 .swiper-container-pointer-events.swiper-container-vertical {
     touch-action: pan-x
 }

 .swiper-slide {
     flex-shrink: 0;
     width: 100%;
     position: relative;
     transition-property: transform
 }
 
 .swiper-slide-ignore-crop-area > div {
    height: 100%;
 }
 
 .swiper-slide-ignore-crop-area img {
    height: 100%;
 }


 .swiper-slide-invisible-blank {
     visibility: hidden
 }

 .swiper-container-autoheight,
 .swiper-container-autoheight .swiper-slide {
     height: auto
 }

 .swiper-container-autoheight .swiper-wrapper {
     align-items: flex-start;
     transition-property: transform, height
 }

 .swiper-container-3d {
     perspective: 1200px
 }

 .swiper-container-3d .swiper-cube-shadow,
 .swiper-container-3d .swiper-slide,
 .swiper-container-3d .swiper-slide-shadow-bottom,
 .swiper-container-3d .swiper-slide-shadow-left,
 .swiper-container-3d .swiper-slide-shadow-right,
 .swiper-container-3d .swiper-slide-shadow-top,
 .swiper-container-3d .swiper-wrapper {
     transform-style: preserve-3d
 }

 .swiper-container-3d .swiper-slide-shadow-bottom,
 .swiper-container-3d .swiper-slide-shadow-left,
 .swiper-container-3d .swiper-slide-shadow-right,
 .swiper-container-3d .swiper-slide-shadow-top {
     position: absolute;
     left: 0;
     top: 0;
     width: 100%;
     height: 100%;
     pointer-events: none;
     z-index: 10
 }

 .swiper-container-3d .swiper-slide-shadow-left {
     background-image: linear-gradient(to left, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))
 }

 .swiper-container-3d .swiper-slide-shadow-right {
     background-image: linear-gradient(to right, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))
 }

 .swiper-container-3d .swiper-slide-shadow-top {
     background-image: linear-gradient(to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))
 }

 .swiper-container-3d .swiper-slide-shadow-bottom {
     background-image: linear-gradient(to bottom, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0))
 }

 .swiper-container-css-mode>.swiper-wrapper {
     overflow: auto;
     scrollbar-width: none;
     -ms-overflow-style: none
 }

 .swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar {
     display: none
 }

 .swiper-container-css-mode>.swiper-wrapper>.swiper-slide {
     scroll-snap-align: start start
 }

 .swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper {
     scroll-snap-type: x mandatory
 }

 .swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper {
     scroll-snap-type: y mandatory
 }

 :root {
     --swiper-navigation-size: 44px
 }

 .swiper-button-next,
 .swiper-button-prev {
     position: absolute;
     top: 50%;
     width: calc(var(--swiper-navigation-size)/ 44 * 27);
     height: var(--swiper-navigation-size);
     margin-top: calc(-1 * var(--swiper-navigation-size)/ 2);
     z-index: 10;
     cursor: pointer;
     display: flex;
     align-items: center;
     justify-content: center;
     color: var(--swiper-navigation-color, var(--swiper-theme-color))
 }

 .swiper-button-next.swiper-button-disabled,
 .swiper-button-prev.swiper-button-disabled {
     opacity: .35;
     cursor: auto;
     pointer-events: none
 }

 .swiper-button-next:after,
 .swiper-button-prev:after {
     font-family: swiper-icons;
     font-size: var(--swiper-navigation-size);
     text-transform: none !important;
     letter-spacing: 0;
     text-transform: none;
     font-variant: initial;
     line-height: 1
 }

 .swiper-button-prev,
 .swiper-container-rtl .swiper-button-next {
     left: -15px;
     right: auto
 }
 
 .swiper-button-prev:after,
 .swiper-container-rtl .swiper-button-next:after {
     content: 'prev'
 }

 .swiper-button-next,
 .swiper-container-rtl .swiper-button-prev {
     right: -15px;
     left: auto
 }

 @media screen and (max-width: 768px) {
   .swiper-button-prev,
   .swiper-container-rtl .swiper-button-next {
       left: 4px;
       right: auto;
   }
   .swiper-button-next,
   .swiper-container-rtl .swiper-button-prev {
       right: 4px;
       left: auto;
   }   
  } 

 .swiper-button-next:after,
 .swiper-container-rtl .swiper-button-prev:after {
     content: 'next'
 }

 .swiper-button-next.swiper-button-white,
 .swiper-button-prev.swiper-button-white {
     --swiper-navigation-color: #ffffff
 }

 .swiper-button-next.swiper-button-black,
 .swiper-button-prev.swiper-button-black {
     --swiper-navigation-color: #000000
 }

 .swiper-button-lock {
     display: none
 }

 .swiper-pagination {
     position: absolute;
     text-align: center;
     transition: .3s opacity;
     transform: translate3d(0, 0, 0);
     z-index: 10
 }

 .swiper-pagination.swiper-pagination-hidden {
     opacity: 0
 }

 .swiper-container-horizontal>.swiper-pagination-bullets,
 .swiper-pagination-custom,
 .swiper-pagination-fraction {
     bottom: 10px;
     left: 0;
     width: 100%
 }

 .swiper-pagination-bullets-dynamic {
     overflow: hidden;
     font-size: 0
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
     transform: scale(.33);
     position: relative
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
     transform: scale(1)
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
     transform: scale(1)
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
     transform: scale(.66)
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
     transform: scale(.33)
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
     transform: scale(.66)
 }

 .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
     transform: scale(.33)
 }

 .swiper-pagination-bullet {
     width: 6px;
     height: 6px;
     display: inline-block;
     margin: 0 10px;
     background: transparent;
     border: 1px solid #fff;
     border-radius: 40%;
     transform: rotate(45deg);    
     opacity: 1
 }

 button.swiper-pagination-bullet {
     border: none;
     margin: 0;
     padding: 0;
     box-shadow: none;
     -webkit-appearance: none;
     -moz-appearance: none;
     appearance: none
 }

 .swiper-pagination-clickable .swiper-pagination-bullet {
     cursor: pointer
 }

 .swiper-pagination-bullet-active {
     background: #ffffff;
 }

 .swiper-container-vertical>.swiper-pagination-bullets {
     right: 10px;
     top: 50%;
     transform: translate3d(0px, -50%, 0)
 }

 .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
     margin: 6px 0;
     display: block
 }

 .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
     top: 50%;
     transform: translateY(-50%);
     width: 8px
 }

 .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
     display: inline-block;
     transition: .2s transform, .2s top
 }

 .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
     margin: 0 4px
 }

 .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
     left: 50%;
     transform: translateX(-50%);
     white-space: nowrap
 }

 .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
     transition: .2s transform, .2s left
 }

 .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
     transition: .2s transform, .2s right
 }

 .swiper-pagination-progressbar {
     background: rgba(0, 0, 0, .25);
     position: absolute
 }

 .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
     background: var(--swiper-pagination-color, var(--swiper-theme-color));
     position: absolute;
     left: 0;
     top: 0;
     width: 100%;
     height: 100%;
     transform: scale(0);
     transform-origin: left top
 }

 .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
     transform-origin: right top
 }

 .swiper-container-horizontal>.swiper-pagination-progressbar,
 .swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
     width: 100%;
     height: 4px;
     left: 0;
     top: 0
 }

 .swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
 .swiper-container-vertical>.swiper-pagination-progressbar {
     width: 4px;
     height: 100%;
     left: 0;
     top: 0
 }

 .swiper-pagination-white {
     --swiper-pagination-color: #ffffff
 }

 .swiper-pagination-black {
     --swiper-pagination-color: #000000
 }

 .swiper-pagination-lock {
     display: none
 }
:root {
    --swiper-navigation-size: 25px;
    --swiper-theme-color: #C5D9E8;      
}
.parallax-slider .swiper-button-prev,
 .swiper-container-rtl .swiper-button-next {
      left: 15px;
}
.parallax-slider .swiper-button-next,
 .swiper-container-rtl .swiper-button-prev {
     right: 15px;
 }
 @media screen and (max-width: 768px) {
   .parallax-slider .swiper-button-prev,
   .swiper-container-rtl .swiper-button-next {
        left: 5px;
  }
  .parallax-slider .swiper-button-next,
   .swiper-container-rtl .swiper-button-prev {
       right: 5px;
   }  
 }
 .swiper-button-prev, .swiper-button-next {
    outline: none;
 }
 .templates-slider .swiper-container {
    display: flex;
    flex-direction: column;
 }
 .templates-slider .swiper-pagination-bullet.swiper-pagination-bullet-active-main {
    background: #25bec8;
    opacity: 1 !important;
 }
 .templates-slider .swiper-pagination {
    bottom: 0;
    position: relative;
    order: 2;
    padding-top: 18px;
    margin: auto;
    width: auto !important;
 }
  @media all and (max-width: 768px) {
    .templates-slider .swiper-pagination {
      padding-top: 40px;
    }
  }
  @media all and (max-width: 768px) {
    .templates-slider .swiper-slide {
      scale: 0.85;
      transition: scale 300ms ease-out;
    }
    .templates-slider .swiper-slide-active {
      scale: 1;
      transition: scale 300ms ease-out;
    }
  }  
 .templates-slider .swiper-pagination-bullet {
    background: #25bec8;
    border-radius: 50%;
    opacity: 0.2; 
    width: 8px;
    height: 8px;
    left: 0 !important;
    transform: none;
    margin: 0 4px;
 }
 @media all and (max-width: 768px) {
  .templates-slider .swiper-pagination-bullet {
    background: #ffffff;
    opacity: 0.47; 
    width: 11px;
    height: 11px;
    border-radius: 50%;
    transform: none;
    margin: 0 8px; 
  }
} 
 .templates-slider .swiper-pagination-bullet-active {
    opacity: 1;
 }
 .templates-slider .swiper-button-next {
    width: 32px;
    height: 32px;
    background: #25bec8 url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzLjI5IDUuMDYiPg0KICA8cG9seWdvbiBwb2ludHM9IjEuODggMi40NCAwLjE3IDAuNyAwLjg5IDAgMy4yOSAyLjQzIDAuNzIgNS4wNiAwIDQuMzYgMS44OCAyLjQ0IiBzdHlsZT0iZmlsbDogI2ZmZiIvPg0KPC9zdmc+DQo=");
    background-size: 10px;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 50%;    
    right: -32px;
    top: 40%; 
 }
 .templates-slider .swiper-button-prev {
    width: 32px;
    height: 32px;
    background: #25bec8 url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMC41MiAxMC41MiI+DQogIDxwb2x5Z29uIHBvaW50cz0iNC42NCA1LjMgNi4zNSAzLjU2IDUuNjMgMi44NiAzLjIzIDUuMjkgNS44IDcuOTIgNi41MiA3LjIyIDQuNjQgNS4zIiBzdHlsZT0iZmlsbDogI2ZmZiIvPg0KPC9zdmc+DQo=");
    border-radius: 50%;
    background-position: center center;
    background-repeat: no-repeat;
    left: -32px;
    top: 40%;
 } 
 .templates-slider .swiper-button-next:after {
   font-size: 15px;
   font-weight: 900;
   color: #ffffff;
   margin-left: 3px;
   content: "";
 }
 .templates-slider .swiper-button-prev:after {
   font-size: 15px;
   font-weight: 900;
   color: #ffffff;
   margin-right: 3px;
   content: "";
 }
 .templates-modal-slider .swiper-button-next {
   right: -40px;
   top: calc(50% + 20px);
 }
 .templates-modal-slider .swiper-button-prev {
   left: -40px;
   top: calc(50% + 20px)
 }
`;
